import { useI18n as originalUseI18n } from "vue-i18n";

export const useI18n = () => {
    const { d: originalD, n: originalN, locale: currentLocale, ...rest } = originalUseI18n();
    // Custom date formatting function
    const d = (
        value: Date | string | number,
        format = 'short',
        locale = currentLocale.value
    ): string => {
        const normalizedLocale = (() => {
            if (locale === 'en') return 'en-GB';
            if (locale === 'yoonly-nl') return 'nl-NL';
            if (locale === 'yoonly-fr') return 'fr-FR';
            return locale;
        })();
        const formattedDate = originalD(value, format, normalizedLocale);

        return formattedDate.replace(/-/g, '/');
    };

    const n = (
        value: number,
        format = '',
        locale = currentLocale.value,
        digits?: number
    ): string => {
        const formattedNumber = originalN(value, format, locale);
        if (format == 'currency')
            return formattedNumber.replace(/[\u00A0.,]/g, '');

        return formattedNumber
    };

    return {
        ...rest,
        d,
        n
    };

};
